import { forwardRef } from 'react';
import { Tab as MuiTab } from '@mui/material';
import type { TabProps } from './types';

const Tab = forwardRef<HTMLDivElement, TabProps>((props, ref) => <MuiTab ref={ref} {...props} />);

export default Tab;
